import Vue from 'vue'

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import u3c from '../components/u3c/u3c.vue'
Vue.component('u3c', u3c)



// WEBPACK FOOTER //
// ./client/plugins/global_plugins.js